import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-24 text-center">
      <h1 className="text-4xl font-bold text-foreground">404</h1>
      <p className="mt-2 text-muted">Page introuvable.</p>
      <Link to="/" className="mt-4 text-primary hover:underline">
        Retour au tableau de bord
      </Link>
    </div>
  );
}
